<template>
    <!-- Categories Widget -->
    <div class="card my-4">
        <h5 class="card-header"><i class="fas fa-tags"></i> Categorias</h5>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                <ul v-for="(categoria,index) in categorias"  :key="categoria.key" v-if="index < limiteC" class="list-unstyled mb-0">
                    <li>
                    <a href="#" @click.prevent="viewPostsFromCategory(categoria)"><i class="fas fa-tags"></i>  {{ categoria }}</a>
                    </li>
                </ul>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-center">
            <button  @click.prevent="updateLimitationCategorias()" type="button" class="btn btn-sm btn-outline-secondary">
                Mostrar {{this.limiteC == 5 ? 'mais' : 'menos'}}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                categorias: [],
                limiteC: 5,
            }
        },
        mounted() {
            this.getCategorias();
        },
        methods: {
            getCategorias(){
                this.$Progress.start();
                axios.get('/api/externalCategorias')
                    .then(response => {
                        this.$Progress.finish();
                        this.categorias = response.data;
                    });
            },
            updateLimitationCategorias(){
                if (this.limiteC == this.categorias.length) {
                    this.limiteC = 5
                }else{
                    this.limiteC = this.categorias.length
                }
            },
            viewPostsFromCategory(data){
                this.$parent.viewPostsFromCategory(data);
            }
        }
    }
</script>
